import React, { useState, useEffect } from 'react';
import axios from 'axios';

function BaoGiaComponent() {
  // State lưu thông tin cấu hình báo giá từ backend
  const [pricingData, setPricingData] = useState(null);
  // State cho thông tin nhập
  const [pickup, setPickup] = useState('');
  const [destination, setDestination] = useState('');
  const [truckType, setTruckType] = useState(''); // Ví dụ: '1-3'
  const [waitingTime, setWaitingTime] = useState(0); // số giờ chờ (nếu có)
  
  // State khoảng cách và giá
  const [distanceGo, setDistanceGo] = useState(null);
  const [distanceReturn, setDistanceReturn] = useState(null);
  const [calculatedPrice, setCalculatedPrice] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Tải dữ liệu báo giá từ backend khi component load
  useEffect(() => {
    axios.get('/api/getPricingData')
      .then(response => {
        setPricingData(response.data);
      })
      .catch(err => {
        console.error('Error fetching pricing data:', err);
        setError('Không thể tải dữ liệu báo giá');
      });
  }, []);

  // Hàm lấy khoảng cách từ GoongMap
  const calculateDistance = async () => {
    setError('');
    setLoading(true);
    try {
      // Lấy API Key của GoongMap và gọi API định tuyến
      const GOONG_API_KEY = "YOUR_GOONG_API_KEY";
      // Ví dụ: API định tuyến của GoongMap, bạn cần tham khảo tài liệu để định dạng tham số chính xác.
      const url = `https://rsapi.goong.io/Direction?api_key=${GOONG_API_KEY}&origin=${pickup}&destination=${destination}`;
      const res = await axios.get(url);
      if (res.data && res.data.routes && res.data.routes.length > 0) {
        const route = res.data.routes[0];
        // Giả sử API trả về khoảng cách theo mét trong key 'distance'
        const distanceKm = Math.round((route.distance / 1000) * 100) / 100;
        // Ở đây ví dụ sử dụng cùng khoảng cách cho chiều đi và chiều về
        setDistanceGo(distanceKm);
        setDistanceReturn(distanceKm);
      } else {
        setError('Không tìm thấy lộ trình từ GoongMap');
      }
    } catch (err) {
      console.error('Lỗi lấy khoảng cách:', err);
      setError('Lỗi kết nối API GoongMap');
    }
    setLoading(false);
  };

  // Hàm tính giá báo dựa trên cấu hình và khoảng cách
  const calculatePrice = () => {
    setError('');
    if (!pricingData || !truckType) {
      setError('Chưa tải dữ liệu báo giá hoặc chưa chọn loại xe');
      return;
    }
    if (distanceGo === null || distanceReturn === null) {
      setError('Chưa tính được khoảng cách');
      return;
    }
    
    // Tìm thông tin giá theo truckType từ pricingData
    const priceConfig = pricingData.pricing_by_km.find(item => item.truck_type_code === truckType);
    if (!priceConfig) {
      setError('Không tìm thấy cấu hình giá cho loại xe đã chọn');
      return;
    }
    const { price_min, price_go, price_return } = priceConfig;
    
    // Tính cước theo công thức: (price_go * km đi) + (price_return * km về)
    const cướcKm = (price_go * distanceGo) + (price_return * distanceReturn);
    // Áp giá tối thiểu
    let basePrice = cướcKm >= price_min ? cướcKm : price_min;
    
    // Nếu có phí lưu xe (theo số giờ chờ), cộng thêm vào
    // Ví dụ: tìm phí lưu xe cho loại xe trong pricingData.waiting_fees
    const fees = pricingData.waiting_fees.filter(item => item.truck_type_code === truckType);
    let waitingFee = 0;
    fees.forEach(feeItem => {
      if (waitingTime >= feeItem.from_hour && waitingTime <= feeItem.to_hour) {
        waitingFee = feeItem.fee;
      }
    });
    
    const totalPrice = basePrice + waitingFee;
    setCalculatedPrice(totalPrice);
  };

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto' }}>
      <h1>Báo Giá Vận Chuyển</h1>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      
      <div>
        <label>Điểm đi:</label>
        <input 
          type="text" 
          value={pickup} 
          onChange={(e) => setPickup(e.target.value)} 
          placeholder="Nhập địa chỉ xuất phát" 
          style={{ width: '100%', padding: '8px', marginBottom: '10px' }}
        />
      </div>
      <div>
        <label>Điểm đến:</label>
        <input 
          type="text" 
          value={destination} 
          onChange={(e) => setDestination(e.target.value)} 
          placeholder="Nhập địa chỉ đích" 
          style={{ width: '100%', padding: '8px', marginBottom: '10px' }}
        />
      </div>
      <button onClick={calculateDistance} style={{ marginBottom: '10px' }}>
        Tính khoảng cách
      </button>
      {loading && <p>Đang tính toán...</p>}
      {distanceGo !== null && (
        <div>
          <p>Khoảng cách chiều đi: {distanceGo} km</p>
          <p>Khoảng cách chiều về: {distanceReturn} km</p>
        </div>
      )}
      
      <div>
        <label>Chọn loại xe:</label>
        <select 
          value={truckType} 
          onChange={(e) => setTruckType(e.target.value)}
          style={{ width: '100%', padding: '8px', marginBottom: '10px' }}
        >
          <option value="">Chọn loại xe</option>
          <option value="1-3">Xe 1-3 Tấn</option>
          <option value="3-5">Xe 3-5 Tấn</option>
          <option value="5-8">Xe 5-8 Tấn</option>
          <option value="8-13">Xe 8-13 Tấn</option>
          <option value="18">Xe 18 Tấn</option>
        </select>
      </div>
      
      <div>
        <label>Thời gian chờ (giờ):</label>
        <input 
          type="number" 
          value={waitingTime} 
          onChange={(e) => setWaitingTime(Number(e.target.value))} 
          placeholder="Nhập giờ chờ nếu có" 
          style={{ width: '100%', padding: '8px', marginBottom: '10px' }}
        />
      </div>
      
      <button onClick={calculatePrice}>Tính giá cước</button>
      
      {calculatedPrice !== null && (
        <div>
          <h2>Giá báo: {calculatedPrice.toLocaleString()} VNĐ</h2>
        </div>
      )}
    </div>
  );
}

export default BaoGiaComponent;
